import React from 'react'

import ReloadButton from '@/components/misc/ErrorMessage/components/ReloadButton'
import { Heading } from '@/components/ui/heading'
import { useIsMinWidthSm } from '@/hooks/useIsMinWidthSm'

interface Props {
  children: React.ReactNode
}

const HeadingWithReloadButton: React.FC<Props> = ({ children }) => {
  const isMinWidthSm = useIsMinWidthSm()

  return (
    <header className="mb-4 flex gap-4">
      <Heading
        size={2}
        className="mb-0"
        style={isMinWidthSm ? undefined : { fontSize: '20px' }}
      >
        {children}
      </Heading>

      <ReloadButton />
    </header>
  )
}

export default HeadingWithReloadButton
